import {Injectable} from '@angular/core';
import {catchError, Observable, throwError} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {State} from '../state';
import {StateContext} from '../state.context';
import {EmailVerificationService} from "../../../shared/services/email-verification/email-verification.service";

/**
 * Starts the page-specific ForgeRock profile-edit journey.
 */
@Injectable({
  providedIn: "root"
})
export class EditState implements State {
  name = 'EditState';

  constructor(
    private stateContext: StateContext,
    private emailVerificationService: EmailVerificationService
  ) {}

  /**
   * Profile edit on 'edit' view for either Login and Contact info.
   */
  start(): void {
    console.debug(`🔑 SERVICE:edit$`);
  }

  /**
   * Update profile information on Submit button for either Login and Contact info.
   */
  onSubmit(obj: Record<string, unknown>, objPrompt: Record<string, string | ((values: Record<string, unknown>) => unknown)> ): Observable<any> {
    return this.emailVerificationService.submitProfileData(obj, objPrompt).pipe(
      switchMap((state => this.stateContext.changeState(state))),
      catchError((err) => {
        console.warn(`🔑 SERVICE:edit$`, err?.message ?? err);
        return throwError(() => err)
      })
    )
  }

  /**
   * Cancel to edit profile information on Cancel button for either Login and Contact info.
   */
  onCancel(): Observable<any> {
    return this.emailVerificationService.cancelUpdateProfileData().pipe(
      switchMap((state => this.stateContext.changeState(state))),
      catchError((err) => {
        console.warn(`🔑 SERVICE:edit$`, err?.message ?? err);
        return throwError(() => err)
      })
    );
  }

}
